import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ExtraKYCContext } from 'data/types'

import { ExtraKYC, Node } from './types'

export type ExtraKYCQuestionsState = {
  data?: ExtraKYC
  fetching: boolean
  hasError: boolean
}

export const initialState: ExtraKYCQuestionsState = {
  fetching: false,
  hasError: false
}

const configSlice = createSlice({
  initialState,
  name: 'extraKYC',
  reducers: {
    error(state) {
      state.fetching = false
      state.hasError = true
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetch(state, action: PayloadAction<ExtraKYCContext>) {
      state.fetching = true
    },
    set(state, action: PayloadAction<ExtraKYC | undefined>) {
      state.hasError = false
      state.fetching = false
      state.data = action.payload
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    submit(state, action: PayloadAction<Array<Node>>) {}
  }
})

export const { actions } = configSlice
export default configSlice.reducer
